import { datadogRum } from '@datadog/browser-rum'
import { USER_JOURNEY_EVENTS } from './constants'
import { JourneyStartedEvent, RecordCompletedJourneyPayload } from './contract'

export interface UserJourneySink {
  journeyStarted: (event: JourneyStartedEvent) => void
  journeyCompleted: (payload: RecordCompletedJourneyPayload) => void
}

type UserJourneyEventName = (typeof USER_JOURNEY_EVENTS)[keyof typeof USER_JOURNEY_EVENTS]

type UserJourneyTestHook = (entry: { type: UserJourneyEventName; event: JourneyStartedEvent | RecordCompletedJourneyPayload }) => void | Promise<void>

const mirrorToTestHook = (type: UserJourneyEventName, event: JourneyStartedEvent | RecordCompletedJourneyPayload): void => {
  const hook = (window as Window & { __ujEventSink?: UserJourneyTestHook }).__ujEventSink
  if (typeof hook === 'function') {
    try {
      void Promise.resolve(hook({ type, event })).catch(() => {})
    } catch {
      // the test hook must never break real reporting
    }
  }
}

const explodeTags = (tags: string[]): Record<string, string> => {
  const fields: Record<string, string> = {}
  for (const tag of tags) {
    const separator = tag.indexOf(':')
    if (separator > 0) {
      fields[`tag_${tag.slice(0, separator)}`] = tag.slice(separator + 1)
    }
  }
  return fields
}

export const datadogUserJourneySink: UserJourneySink = {
  journeyStarted: (event) => {
    datadogRum.addAction(USER_JOURNEY_EVENTS.STARTED, event)
    mirrorToTestHook(USER_JOURNEY_EVENTS.STARTED, event)
  },
  journeyCompleted: (payload) => {
    datadogRum.addAction(USER_JOURNEY_EVENTS.COMPLETED, { ...payload, ...explodeTags(payload.tags) })
    mirrorToTestHook(USER_JOURNEY_EVENTS.COMPLETED, payload)
  },
}
